import { render, staticRenderFns } from "./BgImage.vue?vue&type=template&id=6b7c0f3b"
import script from "./BgImage.vue?vue&type=script&lang=ts"
export * from "./BgImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports